/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const EnumTest = {
  A: "A",
  B: "B",
  C: "C",
  D: "D",
} as const;

export type EnumTest = (typeof EnumTest)[keyof typeof EnumTest];

export type EnumTestEnumType = typeof EnumTest;
export type EnumTestOptional = EnumTest;
export type EnumTestTrackedI = EnumTest;
export type EnumTestTracked = EnumTest;
export type EnumTestMetaI = EnumMetaType<EnumTestEnumType, EnumTest>;
export const EnumTestMeta = typeMetaEnum<EnumTestEnumType, EnumTest>(
  "EnumTest",
  EnumTest,
);
export function transformDatesEnumTest(model: EnumTest) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
